import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Coverage = () => {
  const areas = [
    "Weston-super-Mare",
    "Worle",
    "Burnham-on-Sea",
    "Highbridge",
    "Surrounding areas"
  ];

  return (
    <section className="py-16 bg-royal text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="md:w-1/2">
            <h3 className="text-3xl md:text-4xl font-extrabold mb-4">Areas We Cover</h3>
            <p className="text-blue-100 text-lg mb-6">
              Providing reliable and professional automatic driving lessons across the region. Not sure if we cover your area? Just give us a call!
            </p>
            <div className="flex flex-wrap gap-3">
              {areas.map((area, index) => (
                <div key={index} className="flex items-center bg-blue-800/50 px-4 py-2 rounded-full border border-blue-700">
                  <SafeIcon icon={FiMapPin} className="text-brandOrange mr-2" />
                  <span className="font-semibold">{area}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="md:w-1/3 text-center md:text-right">
            <div className="bg-white text-royal p-8 rounded-2xl shadow-2xl inline-block text-left w-full">
              <h4 className="font-bold text-xl mb-2">Ready to start?</h4>
              <p className="text-gray-600 mb-6">Contact us today to check availability in your area.</p>
              <a href="#contact" className="block w-full text-center bg-brandOrange hover:bg-brandOrangeDark text-white font-bold py-3 px-6 rounded-lg transition-colors">
                Enquire Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Coverage;